import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";
import { Badge } from "../badge";

import "./tabBarItem.css";

export class TabBarItem extends PureComponent {
  render() {
    const { className, label, icon, active, badge, onClick } = this.props;
    const cls = classNames({
      "weui-tabbar__item": true,
      "weui-bar__item_on": active
    }, className);

    const showBadge = badge !== undefined && badge !== null;
    const badgeStyle = {
      position: "absolute",
      top: badge === "" ? 0 : -2,
      right: badge === "" ? -6 : -13
    };

    const IconComponent = typeof icon === "string"
      ? (props) => <img src={ icon } alt="" { ...props } />
      : icon;

    return (
      <div className={ cls } onClick={ onClick } onKeyDown={ onClick } tabIndex={ 0 } role="tab">
        <div aria-hidden="true" style={ { display: "inline-block", position: "relative" } }>
          <IconComponent className="weui-tabbar__icon" />
          { 
            showBadge &&
              <Badge style={ badgeStyle } dot={ badge === "" }>{ badge }</Badge>
          }
        </div>
        <p aria-hidden="true" className="weui-tabbar__label">{ label }</p>
      </div>
    );
  }
}
